import { SUMMARY_TOO_FEW, SUMMARY_NOTHING_NEW } from './writerCopy';

/**
 * Manual "Create Summary" pre-flight. Reads the backend's own verdict from
 * GET /sessions/:id/summary/status (manual_block_reason, computed by the same
 * rule create_interim_summary enforces) — no client-side copy of the rule.
 *
 * @returns {string|null} writer-facing reason the summary would be refused,
 *   or null when it can go ahead (or the status is unknown — the backend
 *   still enforces the rule on create).
 */
export function manualSummaryBlockedMessage(status) {
  const reason = status?.manual_block_reason;
  if (reason === 'too_few_messages') {
    return SUMMARY_TOO_FEW(
      status.manual_min_messages ?? 5,
      status.session_message_count ?? 0,
    );
  }
  if (reason === 'no_new_messages') return SUMMARY_NOTHING_NEW;
  return null;
}
